// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_components_timx-payment_timx-payment_module_ts":"2019fa01620cc28a","src_app_components_common-payment_common-payment_module_ts":"e36b5954dbade316"}[chunkId] + ".js";
};